import {gql} from '@apollo/client';

export const BCP_CHECK_JOBS = gql`
    query BcpCheckJobs($filters: CheckJobQueryFilterTypeInput, $pageRequest: PageRequestTypeInput) {
        bcpCheckJobs(filters: $filters, pageRequest: $pageRequest) {
            success
            code
            message
            content {
                id
                name
                remark
                status
                statusDesc
                userGroupId
                userGroupName
                windowTime
                alarmReceiver
                alarmMode
                sampleRatio
                checkRule
                currVersion
                validVersion
                createUser
                updateUser
                createTime
                updateTime
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export const BCP_CHECK_JOB_CONFIG_VERSIONS = gql`
    query BcpCheckJobConfigVersions($jobId: Long!) {
        bcpCheckJobConfigVersions(jobId: $jobId) {
            success
            code
            message
            content {
                id
                version
                createUser
                createTime
                updateTime
            }
        }
    }
`;

export const BCP_CHECK_JOB_CONFIG_VERSIONS_PAGE = gql`
    query BcpCheckJobConfigVersionsPage($jobId: Long!, $pageRequest: PageRequestTypeInput) {
        bcpCheckJobConfigVersionsPage(jobId: $jobId, pageRequest: $pageRequest) {
            success
            code
            message
            content {
                id
                version
                jobId
                createUser
                createTime
                updateTime
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export const BCP_CHECK_JOB_CONFIG_VERSION_DETAIL = gql`
    query BcpCheckJobConfigVersionDetail($jobId: Long!, $version: Long!) {
        bcpCheckJobConfigVersionDetail(jobId: $jobId, version: $version) {
            success
            code
            message
            data {
                id
                name
                remark
                status
                statusDesc
                userGroupId
                userGroupName
                windowTime
                alarmReceiver
                alarmMode
                sampleRatio
                checkRule
                currVersion
                validVersion
                createUser
                updateUser
                createTime
                updateTime
                dataSources {
                    id
                    type
                    typeDesc
                    config
                    tableName
                    useFields
                    groupRule
                    filterRule
                    mustExist
                }
            }
        }
    }
`;

export const BCP_CHECK_JOB = gql`
    query BcpCheckJob($id: Long!) {
        bcpCheckJob(id: $id) {
            success
            code
            message
            data {
                id
                name
                remark
                status
                statusDesc
                userGroupId
                userGroupName
                windowTime
                alarmReceiver
                alarmMode
                sampleRatio
                checkRule
                currVersion
                validVersion
                createUser
                updateUser
                createTime
                updateTime
                dataSources {
                    id
                    jobId
                    type
                    typeDesc
                    config
                    tableName
                    useFields
                    groupRule
                    filterRule
                    mustExist
                }
            }
        }
    }
`;
